import BemIt from "@gtechdoodler/bem-it";

import Box from "../../../layout/boxes/Box";
import {
	StyledLabel,
	StyledSecondaryButton,
} from "./ProxyBidDynamicLabel.styles";
import { ProxyBidLabelProps } from "./ProxyBidDynamicLabel.types";

const ProxyBidDynamicLabel = ({
	label,
	handleSecondaryButtonClick,
	shouldDisplaySecondaryButton,
	buttonLabel,
	variant,
}: ProxyBidLabelProps) => {
	const block = new BemIt("ProxyBidLabel");

	return (
		<Box className={block.out} width="100%" display="flex" marginBottom="xs">
			<StyledLabel variant={variant} size="md" bold>
				{label}
			</StyledLabel>
			{shouldDisplaySecondaryButton && (
				<StyledSecondaryButton onClick={handleSecondaryButtonClick}>
					{buttonLabel}
				</StyledSecondaryButton>
			)}
		</Box>
	);
};
export default ProxyBidDynamicLabel;
